import React, { MouseEvent, useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { Layout, Menu, Dropdown, message, Spin, Avatar } from 'antd';
import { useAsyncEffect, useRequest } from 'ahooks';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { userInfo as recoilUserInfo, appReady } from '../../recoil';
import { envConfig } from '../../envConfig';
import { getLocaleLabel, getLocaleOptions, i18n as i, LocaleOption, PlatformType, setLocale } from '../../i18n';
import { getLocale } from '../../i18n';
import { convertContext, generateConfig } from '../../gs-utils/core/utils';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { getToken, getUserInfo } from '../../api';
import './mainLayout.less';
import { getApplicationList, checkNeedLogout } from '../../api/cedar';
import { GlobalOutlined } from '@ant-design/icons';
import avatar from "../../assets/images/avatar.png"
import { HeaderApplicationGrid, filterPermissionApps, BASE_APP_CONFIGS_LIST, CookieConsent, } from '../../components/gs-web-ui';
import { PlatformAppType, mergeAppConfig, getAppConfigs } from '../../components/gs-web-ui/AppGrid/baseConfig';
import developerSvg from '../../assets/images/developer.svg';
import { loginRedirect, logoutRedirect } from '../../gs-utils/core/config/domain';
import { Footer as GsFooter } from '../../components/gs-web-ui/Footer';
const { Header, Content, Footer, Sider } = Layout;

export function MainLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const ticket = new URLSearchParams(window.location.search).get('sso_ticket');
  const [selectedKey, setSelectedKey] = useState<Array<string>>(['accessKeyManagement'])
  const [OpenKey, setOpenKey] = useState<Array<string>>(['developerCenter'])
  const [userInfo, setUserInfo] = useRecoilState(recoilUserInfo);
  const [applicationPermissions, setApplicationPermissions] = useState<string[]>([]);
  const [isDEVELOPER, setIsDEVELOPER] = useState<boolean>(false);
  const [isCheckingLogout, setIsCheckingLogout] = useState<boolean>(false);
  const DEVELOPER_APP_CONFIG = BASE_APP_CONFIGS_LIST.map(item => {
    if (item.key === PlatformAppType.OPEN_PLATFORM) {
      return {
        ...item,
        key: PlatformAppType.OPEN_PLATFORM,
        icon: developerSvg,
        name: i('开发者中心'),
      }
    }
    return item
  })
  
  const hasPersonalInfoPermission = useMemo(() => {
    return applicationPermissions.includes("PersonalInformation")
  }, [applicationPermissions])

  const setAppReady = useSetRecoilState(appReady);
  // 预留位置，为国际化做准备

  const getDataCenterPerssions = async () => {
    try {
      const res = await getApplicationList(userInfo.person.id)
      setApplicationPermissions(res?.data || [])
    } catch (err: any) {
      message.error(i('获取应用权限失败'))
    }
  }

  /**
   * 检查用户是否需要强制退登
   * write by cursor
   */
  const checkUserLogoutStatus = async () => {
    setIsCheckingLogout(true);
    try {
      const res = await checkNeedLogout();
      if (res?.code === 0 && res?.data?.needLogout) {
        // 需要强制退登
        message.warning(i('account_changed_error'));
        setTimeout(() => {
          setIsCheckingLogout(false);
          handleLogout();
        }, 1500);
        return false; // 阻止后续流程
      }
      setIsCheckingLogout(false);
      return true; // 允许继续
    } catch (err: any) {
      // 如果检查失败，可以选择继续流程或者退登
      // 这里选择继续流程，避免因为网络问题阻塞用户
      setIsCheckingLogout(false);
      return true;
    }
  }

  useEffect(() => {
    if (userInfo.person) {
      getDataCenterPerssions()
    }
  }, [userInfo.person])

  // ticket交换token
  const { runAsync: runGetTokenAsync } = useRequest(getToken, {
    manual: true,
    onSuccess: (data) => {
      const token = data.data
      if (token.accessToken) {
        localStorage.setItem('accessToken', token.accessToken);
        localStorage.setItem('refreshToken', token.refreshToken);
        setTimeout(() => {
          runGetUserInfo()
        }, 1000)
        window.history.pushState({}, "client", "/developer/#/")
        navigate('/developerCenter/accessKeyManagement');
        setSelectedKey(['accessKeyManagement'])
      }
    },
    onError: (err) => {
      console.log(err);
      // TODO: 错误处理 重定向回login
      message.error(i('token获取失败，请重新登录'));
      logoutRedirect();
    }
  })

  // 获取用户信息
  const { run: runGetUserInfo } = useRequest(getUserInfo, {
    manual: true,
    onSuccess: (res) => {
      setAppReady(true)
      const data = convertContext(res?.data) as any
      if (data) {
        const isDEVELOPER = data?.roles?.some((role: any) => role.code === 'DEVELOPER')
        if (!isDEVELOPER) navigate('/exception/403');
        setIsDEVELOPER(isDEVELOPER)
        setUserInfo(data)
      }
    },
    onError: (err) => {
      message.error(i('用户信息获取失败，请重新登录'));
      logoutRedirect();
    }
  })

  useAsyncEffect(async () => {
    const token = localStorage.getItem("accessToken");

    const routesArray = location.pathname.split('/');
    if (routesArray[routesArray.length - 1]) {
      setSelectedKey([routesArray[routesArray.length - 1]])
    } else {
      setSelectedKey(['accessKeyManagement'])
    }
    setOpenKey([routesArray[routesArray.length - 2]])

    // 获取用户信息
    // if(userInfo.person)

    if (ticket) {
      // 去换token
      await runGetTokenAsync(ticket)
    } else {
      if (token) {
        const canContinue = await checkUserLogoutStatus();
        if (!canContinue) {
          return;
        }
        // 只要存在token
        if (!userInfo.person) {
          runGetUserInfo()
        }
        // 没有token sso登录
        if (location.pathname === '/') {
          navigate('/developerCenter/accessKeyManagement');
        }

      } else {
        /*
          * 环境：prod
          * app_url： 为当前站点页面全路径
        */
        loginRedirect();
      }
    }
  }, [])

  const handleMenuSelect = ({ keyPath }: any) => {
    console.log(keyPath)
    navigate(`/${keyPath[1]}/${keyPath[0]}`);
    setSelectedKey([keyPath[0]])
  }

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    logoutRedirect();
  }

  const changeLanguage = (e: MouseEvent, item: LocaleOption) => {
    e.preventDefault()
    console.log(item.value)
    setLocale(item.value)
    window.location.reload()
  }

  if (isCheckingLogout) {
    return <Spin size="large" />
  }

  return (
    <Layout className='main'>
      <Header className="site-layout-sub-header-background" style={{ padding: '0 24px 0 0' }}>
        <div className="brand-platform">
          <HeaderApplicationGrid
            availableApps={filterPermissionApps(DEVELOPER_APP_CONFIG, 
              { applicationPermissionList: applicationPermissions, internalPerson: userInfo.internalPerson })}
            currentAppKey={PlatformAppType.OPEN_PLATFORM}
          />
          <CookieConsent />
        </div>
        <div>
          <span
            className="header-lang-title-show"
            onClick={() => window.open(
              `${(generateConfig() as any).developerUrl}/v3docs/${getLocale() === 'zh-CN' ? 'zh_CN' : 'en_US'}/OpenAPI%20V3/authentication/Get%20OAuth%20Token`,
              '_blank'
            )}
          >
            <svg className="header-docs-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M4.5 5.5A2.5 2.5 0 0 1 7 3h4.5v16H7a2.5 2.5 0 0 0-2.5 2.5v-16Z"></path>
              <path d="M19.5 5.5A2.5 2.5 0 0 0 17 3h-5.5v16H17a2.5 2.5 0 0 1 2.5 2.5v-16Z"></path>
              <path d="M4.5 21.5h15"></path>
            </svg>
            {i('查看接口文档')}
          </span>
          <Dropdown menu={{
            items: getLocaleOptions(PlatformType.DEVELOPER).map((item: LocaleOption) => ({
              key: item.value,
              label: <a onClick={(e) => changeLanguage(e, item)}>{item.label}</a>,
              className: 'header-dropdown-lang-item'
            })),
            className: 'header-dropdown-lang-menu'
          }} >
            <span className="header-lang-title-show">
              <GlobalOutlined style={{ marginRight: 5 }} />
              <span>{getLocaleLabel(getLocale(), PlatformType.DEVELOPER)}</span>
            </span>
          </Dropdown>

          <Dropdown menu={{
            items: hasPersonalInfoPermission ? [
              {
                key: 'myProfile',
                label: <a onClick={() => { window.location.href = envConfig.myProfile + '?locale=' + getLocale() }}>{i("基本资料")}</a>,
                className: "header-dropdown-lang-item"
              },
              {
              key: 'logout',
              label: <a onClick={handleLogout}>{i("退出登录")}</a>,
              className: "header-dropdown-lang-item"
            }] : [
              {
                key: 'logout',
                label: <a onClick={handleLogout}>{i("退出登录")}</a>,
                className: "header-dropdown-lang-item"
              }
            ],
            className: "header-dropdown-lang-menu"
          }}>
            <span className="header-lang-title-show" style={{ padding: '0 12px' }}>
            <Avatar
                src={avatar}
                style={{ backgroundColor: "#F7F7F7", margin: '5px 8px 5px 0' }}
            />
              <span>{userInfo.person ? userInfo.person.username : i('未登录')}</span>
            </span>
          </Dropdown>
        </div>
      </Header>
      <Layout>
        {
          isDEVELOPER &&
          <Sider
            breakpoint="lg"
            collapsedWidth="0"
            style={{ background: '#fff' }}
          >
            <Menu mode="inline"
              selectedKeys={selectedKey[0] ? selectedKey : ['accessKeyManagement']}
              defaultOpenKeys={OpenKey[0] ? OpenKey : ['developerCenter']}
              onSelect={handleMenuSelect}>
              <Menu.SubMenu key="developerCenter" title={i('开发者中心')}>
                <Menu.Item key="accessKeyManagement" title={i('我的AccessKey')}>
                  {i('我的AccessKey')}
                </Menu.Item>
                <Menu.Item key="callbackAddress" title={i('企业回调地址')}>
                  {i('企业回调地址')}
                </Menu.Item>
                <Menu.Item key="appManagement" title={i('应用管理')}>
                  {i('应用管理')}
                </Menu.Item>
              </Menu.SubMenu>
            </Menu>
          </Sider>
        }
        <Content style={{ margin: '24px 16px 0' }}>
          <div className="site-layout-background" style={{ padding: 24, minHeight: 360, overflow: 'auto' }}>
            {JSON.stringify(userInfo) !== '{}'
              ? <Outlet />
              : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }} ><Spin size="large" /></div>
            }
          </div>
        </Content>
      </Layout>
      <Footer style={{ textAlign: 'center', padding: 0 }}>
        <GsFooter />
      </Footer>
    </Layout>
  );
}
